import { render } from "./RegulationsStep.vue?vue&type=template&id=9a9faaf8&scoped=true"
import script from "./RegulationsStep.vue?vue&type=script&lang=js"
export * from "./RegulationsStep.vue?vue&type=script&lang=js"

import "./RegulationsStep.vue?vue&type=style&index=0&id=9a9faaf8&scoped=true&lang=css"

import exportComponent from "/builds/ser-kso/new-claim-form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a9faaf8"]])

export default __exports__